import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { TContent } from '@/config/types'
import { PageName } from '@/enums/pageName'
import { PaymentMethod, PaymentPlatform } from '@/enums/payments'
import { getPath } from '@/utils/urlUtils'

import { PageTitle } from '@/components/pageTitle'
import { TextHTML } from '@/components/typography'
import { RoundCheckbox3 } from '@/shared/icons/RoundCheckbox3'

import { useAuth } from '@/auth/useAuth'
import { useSession } from '@/core/session/useSession'
import { trackPageComplete, trackPageView } from '@/events/events'

import { TPreLTPPageProps } from './types'

const pageName = PageName.preLtp

export const PreLTPPage = ({
  pageConfig,
  getItem,
  config,
  setLastVisitedItem,
}: TPreLTPPageProps) => {
  const { user } = useAuth()
  const sessionContext = useSession()
  const navigate = useNavigate()

  const { pageTitle, contentDetails, header, description, iconNode } = pageConfig

  const selectedContentPriceId = getItem(PageName.selectLTP)
  const contentData = useMemo<TContent | undefined>(
    () => contentDetails.find((plan) => plan.contentId === selectedContentPriceId),
    [contentDetails, selectedContentPriceId]
  )
  const paymentMethod = (getItem('paymentMethod') as PaymentMethod) || undefined
  const paymentPlatform = (getItem('paymentPlatform') as PaymentPlatform) || undefined

  useEffect(
    () => {
      trackPageView(
        pageName,
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user,
        [],
        [],
        contentData?.internalPriceId,
        paymentMethod,
        paymentPlatform
      )

      document.title = pageTitle
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    const timerId = setTimeout(() => {
      trackPageComplete(
        pageName,
        [],
        config.PARTNER_ID,
        config.APP_ID,
        config.PAGE_SET_ID,
        sessionContext,
        user,
        [],
        contentData?.internalPriceId,
        paymentMethod,
        paymentPlatform
      )

      setLastVisitedItem(pageName)
      navigate(getPath(PageName.selectLTP))
    }, 3000)

    return () => {
      clearTimeout(timerId)
    }
  }, [
    navigate,
    setLastVisitedItem,
    config,
    sessionContext,
    user,
    contentData,
    paymentMethod,
    paymentPlatform,
  ])

  const className = `page page-${pageName}`

  return (
    <div className={className}>
      <div className="icon-container">
        {iconNode && iconNode}
        {!iconNode && <RoundCheckbox3 />}
      </div>
      <PageTitle title={header} />
      <TextHTML title={description} className="page-description" />
    </div>
  )
}
